import { debounce } from 'lodash';
import { useEffect, useState } from 'react';

const noOpFn = () => {};

const getFilterChangeHandler = ({ applyFilterOnValueChange, debounceMs, form }) => {
	if (!applyFilterOnValueChange) {
		return noOpFn;
	}

	const applyFilterFn = form.submit.bind(form);

	if (debounceMs <= 0) {
		return applyFilterFn;
	}

	// can be improved after antd will be updated to 4.20
	// with subscribe on values change for [name] via Form.useWatch
	return debounce(applyFilterFn, debounceMs, { trailing: true });
};

// We are not using useCallback as use callback need to get function to cache but the function that we need to cache can change,
// and we want the same callback function so the lodash debounce won't cause problems
const useFilterChangeHandler = ({ applyFilterOnValueChange, debounceMs, form }): (() => void) => {
	const [filterChangeHandler, setFilterChangeHandler] = useState(() =>
		getFilterChangeHandler({ applyFilterOnValueChange, debounceMs, form })
	);

	useEffect(() => {
		// Passing a function to `setFilterChangeHandler` as the `getFilterChangeHandler` result is a function so without it
		// `setFilterChangeHandler` would try to execute it thinking it's a functional update
		setFilterChangeHandler(() => getFilterChangeHandler({ applyFilterOnValueChange, debounceMs, form }));
	}, [applyFilterOnValueChange, debounceMs, form]);

	return filterChangeHandler;
};

export default useFilterChangeHandler;
